import {
  OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_INVALID,
  OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_LOAD,
  OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_VALID,
  OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_VALUE_UPDATE,
  OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_ID_SET,
  OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_MODAL_SHOW,
  OWNER_AUTHORIZED_REP_TEAM_SHOW_VERIFICATION_MODAL,
} from 'actions/admin/team/action-types';
import { UserModalState } from 'components/shared/modal/InviteUserModal';

export const initialState = {
  currentUserId: 0,
  form: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    rolesId: null,
  },
  invalidFields: [],
  showInviteUserModal: false,
  userModalState: UserModalState.NEW, // one of UserModalState
  validationMessage: '',
  verificationModal: null,
};

export default function ownerAuthorizedRepTeamUiReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_INVALID:
      return {
        ...state,
        invalidFields: action.payload.invalidFields,
        validationMessage: action.payload.message,
      };

    case OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_LOAD:
      return {
        ...state,
        form: action.payload,
        invalidFields: [],
        validationMessage: '',
      };

    case OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_VALID:
      return {
        ...state,
        invalidFields: [],
        validationMessage: '',
      };

    case OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_FORM_VALUE_UPDATE:
      return {
        ...state,
        form: {
          ...state.form,
          [action.payload.attribute]: action.payload.value,
        },
      };

    case OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_ID_SET:
      return {
        ...state,
        currentUserId: action.payload,
      };

    case OWNER_AUTHORIZED_REP_TEAM_INVITE_USER_MODAL_SHOW:
      const newState = {
        ...state,
        showInviteUserModal: action.payload.open,
      };
      if (action.payload.state !== undefined) {
        newState['userModalState'] = action.payload.state;
      }

      return newState;

    case OWNER_AUTHORIZED_REP_TEAM_SHOW_VERIFICATION_MODAL:
      return {
        ...state,
        verificationModal: action.payload,
      };

    default:
      return state;
  }
}
